const BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export async function getSongs() {
  const res = await fetch(`${BASE}/songs`);
  return res.json();
}

export async function getLyrics(songId) {
  const res = await fetch(`${BASE}/songs/${songId}/lyrics`);
  return res.json();
}

export async function logPlay(songId, songTitle, milestone = "start", secondsElapsed = 0) {
  await fetch(`${BASE}/plays`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      song_id:         songId,
      song_title:      songTitle,
      milestone:       milestone,
      seconds_elapsed: secondsElapsed,
    }),
  }).catch(console.warn);
}

export async function getComments(songId) {
  const res = await fetch(`${BASE}/comments/${songId}`);
  return res.json();
}

export async function postComment(songId, author, text) {
  await fetch(`${BASE}/comments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ song_id: songId, author, text }),
  });
}

export async function postVote(songId, direction) {
  await fetch(`${BASE}/votes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ song_id: songId, direction }),
  });
}

export async function getUserVotes(userId) {
  const res = await fetch(`${BASE}/uservotes/${userId}`);
  return res.json();
}

export async function saveUserVote(userId, songId, direction) {
  await fetch(`${BASE}/uservotes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      user_id:   userId,
      song_id:   songId,
      direction: direction,
    }),
  }).catch(console.warn);
}